export function initWorker() {
    return new Promise((resolve, reject) => {
        const worker = new Worker(new URL('./rays.worker.js?worker', import.meta.url), { type: 'module' });

        worker.addEventListener('error', (error) => {
            console.error('Worker error:', error);
            worker.terminate();
            reject(error);
        });

        worker.addEventListener('message', (event) => {
            if (event.data === 'ready') resolve(worker);
        });
    });
}
